import { getUserObject } from "../../../../../utils/getUserObject";

export const getTargetUserId = (conversationUserIds) => {
    const arrayCondition = Array.isArray(conversationUserIds);

    if (!arrayCondition) {
        throw new Error(`"conversationUserIds" must be array`);
    };

    const lengthCondition = conversationUserIds.length === 2;

    if (!lengthCondition) {
        throw new Error(`conversationUserIds array must contain two elements`);
    };

    const typeCondition = conversationUserIds.every((el) => typeof el === 'number');

    if (!typeCondition) {
        throw new Error(`conversationUserIds array must be number array`);
    };


    const loggedUserId = getUserObject()?.userid;

    const idsFiltered = conversationUserIds.filter((id) => id !== loggedUserId);

    const targetUserId = idsFiltered[0];

    return targetUserId;
};